<kendo-dialog [minWidth]="500" *ngIf="cancelFormActive" (close)="closeCancel()">
    <kendo-dialog-titlebar>
        <h3>{{'CANCEL-APPOINTMENT' | translate}}</h3>
    </kendo-dialog-titlebar>
    <form [formGroup]="appointmentForm" class="k-form">
        <label class="k-form-field mt-3">
            <span class="k-text-uppercase dark">
                {{'TYPE' | translate}} *
            </span>
            <kendo-combobox [filterable]="false" formControlName="status" [data]="statusTypes" [textField]="'text'"
                [valueField]="'id'">
                <ng-template kendoComboBoxItemTemplate let-dataItem>
                    {{ dataItem.name | translate }}
                </ng-template>
            </kendo-combobox>
            <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="appointmentForm.controls['cancelReason'].invalid && appointmentForm.controls['cancelReason'].touched">
                {{'REQUIRED-FIELD-TYPE' | translate}}
            </div>
        </label>
        <label class="k-form-field mt-3">
            <span class="k-text-uppercase dark">
                {{'CANCEL-REASON' | translate}} *
            </span>
            <kendo-combobox [filterable]="true" (filterChange)="cancelReasonFilter($event)" (close)="searchTerm=''"
                formControlName="cancelReason" [data]="reasonsFiltered" [placeholder]="'TYPE-OR-SELECT' | translate"
                [textField]="'displayName'" [valueField]="'id'">
                <ng-template kendoComboBoxItemTemplate let-dataItem>
                    <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
                    </span>
                </ng-template>
            </kendo-combobox>
            <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="appointmentForm.controls['cancelReason'].invalid && appointmentForm.controls['cancelReason'].touched">
                {{'CANCEL-REASON-REQUIRED' | translate}}
            </div>
        </label>
        <label class="k-form-field">
            <label class="k-text-uppercase dark" for="comments">{{'COMMENTS' | translate}}</label>
            <textarea id="comments" class="w-100" kendoTextArea rows="3" maxlength="250" formControlName="comments">
            </textarea>
        </label>
        <label class="k-form-field" *ngIf="warningMessage">
            <i class="fas fa-exclamation-triangle icon-warn"></i>
            <span class="k-text-uppercase icon-warn text-center warn-modal-text">
                {{'NO-COMMUNICATION-ON-CANCELLATION' | translate:patientLabel}}
            </span>
        </label>
    </form>
    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
    <kendo-dialog-actions>
        <button kendoButton type="button" (click)="closeCancel()">
            {{ 'CANCEL' | translate}}
        </button>
        <button appPreventClick preventTime="8000" kendoButton type="button" (click)="cancelAppointment()"
            [disabled]="appointmentForm.invalid || !appointmentForm.dirty">
            {{ 'SAVE' | translate}}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>